define(["data/config"], function(config) {
    var $searchField;

    var resetList = function() {
        $(".attendee").removeClass("is-hidden");
    };

    var initSearch = function() {
        var timer;
        $searchField.on("keyup", function(e) {
            timer && clearTimeout(timer);
            var query = $(this).val();
            timer = setTimeout(function() {
                resetList();
                if (query.length > 1) {
                    search(query);
                }
            }, 300);
        });
    };

    var resetSearch = function() {
        $searchField.val("");
        resetList();
    };

    var search = function(query) {
        $(".attendees-filter-tag").removeClass("is-active");

        $(".attendee").each(function(index) {
            var name = $(this)
                .find(".attendee-name strong")
                .text();
            var headline = $(this)
                .find(".attendee-headline")
                .text();
            var company = $(this)
                .find(".attendee-company")
                .text();

            var body = (name + " " + headline + " " + company).toLowerCase();
            query = query.toLowerCase();

            if (body.indexOf(query) === -1) {
                $(this).addClass("is-hidden");
            }
        });
    };

    var filters;

    var initFilter = function() {
        var that = this;
        $(".attendees-filter-tags").on(
            "click",
            ".attendees-filter-tag",
            function(e) {
                e.preventDefault();
                resetList();
                filters = [];
                var action = $(this).hasClass("is-active")
                    ? "deactivate"
                    : "activate";
                $(".attendees-filter-tag").removeClass("is-active");
                if (action == "activate") {
                    filters.push($(this).data("tags"));
                    $(this).addClass("is-active");
                }
                filter();
            }
        );
    };

    var filter = function() {
        for (var j = 0; j < filters.length; j++) {
            var query = filters[j];
            $(".attendee").each(function(index) {
                var headline = $(this)
                    .find(".attendee-headline")
                    .text()
                    .toLowerCase();

                if (headline.indexOf(query) === -1) {
                    $(this).addClass("is-hidden");
                }
            });
        }
    };

    var apply = function($element) {
        $searchField = $("#attendees-filter-search-field");
        initSearch();
        initFilter();
    };

    return {
        name: "attendees-filter",
        apply: apply
    };
});
